import * as t from '@/types'
import Routes from '@/routes'

const variables: t.Variable[] = [
  {
    name: 'Childcare',
    type: t.VariableType.single,
    description: 'The cost of keeping your children in Creche or with a child minder.',
    variable: 'Childcare_Amt',
    frequency: 'Childcare_Freq',
    placeholder: '0.00'
  },
  {
    name: 'Groceries',
    type: t.VariableType.single,
    description: 'The weekly shop - food, essentials and treats.',
    variable: 'Groceries_Amt',
    frequency: 'Groceries_Freq',
    placeholder: '0.00'
  },
  {
    name: 'Entertainment (Cinema, nights / dinners out etc)',
    type: t.VariableType.single,
    description: 'Consider cinema, nights / dinners out, takeaways etc.',
    variable: 'Entertainment_Amt',
    frequency: 'Entertainment_Freq',
    placeholder: '0.00'
  },
  {
    name: 'Petrol / Diesel',
    type: t.VariableType.single,
    description: 'Cost of running your car. This may be included in your utility figure if you drive electric',
    variable: 'Petrol_Diesel_Amt',
    frequency: 'Petrol_Diesel_Freq',
    placeholder: '0.00'
  },
  {
    name: 'Public Transport (Bus, Train, Taxis etc)',
    type: t.VariableType.single,
    description: 'Consider the commute to / from work each day',
    variable: 'Public_Transport_Amt',
    frequency: 'Public_Transport_Freq',
    placeholder: '0.00'
  },
]

const name = 'Day 2 Day'
const title = 'Your Day to Day Living Expenses'
// tslint:disable-next-line
const description = "Our Day to Day expenses are ones that can add up really quickly. That said, this is also one of the areas that we can sometimes cut back if we find we are eating out too much or spending too much money on travel when cheaper alternative are available. Input how you spend your money today and you can tweak this later if necessary."
const outro = ''
const link = Routes.step3

const stepDefinition: t.StepDefinition = {
  index: 3,
  name,
  title,
  description,
  variables,
  outro,
  link,
}

export default stepDefinition
